import { render, staticRenderFns } from "./OneChatFiendList.vue?vue&type=template&id=f8e34bc2&"
import script from "./OneChatFiendList.vue?vue&type=script&lang=js&"
export * from "./OneChatFiendList.vue?vue&type=script&lang=js&"
import style0 from "./OneChatFiendList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports